/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService, NbCardModule, NbIconModule, NbButtonModule, NbInputModule, NbTooltipModule, NbToggleModule, NbCheckboxModule } from '@nebular/theme';
import { Actions, ofActionCompleted, Store } from '@ngxs/store';
import { first, Observable, Subject, takeUntil } from 'rxjs';
import { EditContentComponent } from 'src/app/features/content/content-table/edit-content/edit-content.component';
import { ContentState } from 'src/app/features/content/redux/content.state';
import { EditInsightComponent } from 'src/app/features/insights/insights-table/edit-insight/edit-insight.component';
import { InsightsState, LoadInsight, LoadInsightSuccess } from 'src/app/features/insights/redux';
import { SurveysState } from 'src/app/features/surveys/redux';
import { Content } from 'src/app/models/content';
import { Insight } from 'src/app/models/insight';
import {
  ACTIONS,
  CAMPAIGN_CATEGORIES,
  CAMPAIGN_CHANNELS,
  CAMPAIGN_SUBCATEGORIES,
  CAMPAIGN_TYPES,
  CONFIG_REGEX,
  METADATA_TYPES,
  PUSH_NOTIFCATION_TYPES
} from 'src/app/shared/constants/general-constants';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { RouterState } from '../../../auth/redux';
import { CampaignState } from '../../redux';
import { AppendCampaignEventTriggers, PostCampaign } from '../../redux/campaign.actions';
import { NgIf, NgFor, AsyncPipe, TitleCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';

@Component({
    selector: 'app-edit-campaign',
    templateUrl: './edit-campaign.component.html',
    styleUrls: ['./edit-campaign.component.css', '../../../../shared/common_syles.css'],
    imports: [NbCardModule, NgIf, NbIconModule, NbButtonModule, FormsModule, NbInputModule, SharedModule, NbTooltipModule, NgSelectComponent, NgFor, NgOptionComponent, NbToggleModule, NbCheckboxModule, AsyncPipe, TitleCasePipe]
})
export class EditCampaignComponent implements OnInit, OnDestroy {
  public campaign$: Observable<any[]> = inject(Store).select(CampaignState.campaign);
  public insight$: Observable<any[]> = inject(Store).select(InsightsState.allInsights);
  public content$: Observable<any[]> = inject(Store).select(ContentState.content);
  public survey$: Observable<any[]> = inject(Store).select(SurveysState.surveys);
  public eventTrigger$: Observable<any[]> = inject(Store).select(CampaignState.eventTriggers);
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe: Subject<void> = new Subject();

  public tagInput = '';
  public insights;

  public campaign;
  public action;
  public content;
  public selectedSurveys = [];
  public allSurveys = [];
  public hideInsightSelect;

  public username = '';

  //Hold value for Jira tag dropdown
  public items;
  //Hold new values added by user in Jira like tag dropdown. We sent this to redux to add new values for reuse
  public newItems = [];

  public campaigns = [];
  public condition = { AND: [] };
  public condition_all = [];
  public condition_any = [];
  public condition_not_all = [];
  public condition_not_any = [];
  public time_frame;
  public show_condition: boolean;
  public show_condition_all: boolean;
  public show_condition_any: boolean;
  public show_condition_not_all: boolean;
  public show_condition_not_any: boolean;
  public thisRegex = CONFIG_REGEX;

  public pushNotificationTypes = PUSH_NOTIFCATION_TYPES;
  public metadataTypes = METADATA_TYPES;
  public campaignTypes = CAMPAIGN_TYPES;
  public campaignChannels = CAMPAIGN_CHANNELS;
  public campaignCategories = CAMPAIGN_CATEGORIES;
  public campaignSubCategories = CAMPAIGN_SUBCATEGORIES;

  constructor(
    protected ref: NbDialogRef<EditCampaignComponent>,
    private store: Store,
    private action$: Actions,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  public ngOnInit() {
    this.campaign$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.campaigns = data));
    this.campaigns = this.campaigns.filter((campaign) => campaign.id !== this.campaign.id);
    this.survey$.pipe(takeUntil(this.unsubscribe)).subscribe((data) =>
      data.forEach((item) => {
        const obj = { name: item.survey_name, id: item.survey_id };
        this.allSurveys.push(obj);
      })
    );
    if (this.campaign.responses) {
      this.campaign.responses.forEach((item) => {
        const obj = { name: item.name, id: item.id };
        this.selectedSurveys.push(obj);
      });
    }
    this.insight$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.insights = data));
    this.content$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.content = data));
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));

    this.deserializeCondition();
  }

  public compareSurveys(item: any, selected: any): boolean {
    return item && selected ? item.id === selected.id : item === selected;
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public save() {
    let edit;
    if (this.action === ACTIONS.EDIT) {
      edit = true;
      this.campaign.last_updated_by = this.username;
    } else {
      this.campaign.created_by = this.username;
      this.campaign.last_updated_by = this.username;
    }

    this.campaign.responses = this.selectedSurveys;
    this.serializeCondition();

    this.store.dispatch(new PostCampaign(this.campaign, edit));
    this.store.dispatch(new AppendCampaignEventTriggers(this.newItems));
    this.ref.close();
  }

  public close() {
    this.dialogService
      .open(NgxGenericModalComponent, {
        context: {
          title: $localize`Confirm Close`,
          message: $localize`Are you sure that you want to close the window? Any changes that you have made will be lost.`
        }
      })
      .onClose.subscribe((data) => {
        if (data) {
          this.ref.close();
        }
      });
  }
  public add() {
    const val = this.tagInput.trim();
    if (val) {
      this.onItemAdded(val);
      this.tagInput = '';
    }
  }
  /** This method is just for parse checking. May be needed later on tho! */
  public pushChanged($event) {
    this.campaign.push_notification_type = $event;
  }

  /** Used for NGX-Chips - Jira like tags for campaign event triggers */
  public onItemRemoved(event) {
    this.campaign.event_triggers = Object.assign([], this.campaign.event_triggers);
    this.campaign.event_triggers = this.campaign.event_triggers.filter((e) => e !== event);
    this.newItems = this.newItems.filter((e) => e !== event);
  }

  /** Used for NGX-Chips - Jira like tags for campaign event triggers */
  public onItemAdded(event) {
    this.campaign.event_triggers = Object.assign([], this.campaign.event_triggers);
    this.campaign.event_triggers.push(event.value);
    this.newItems.push(event.value);
  }

  public editContent(event) {
    const found = this.content.find((element) => element.content_id === event);
    if (found) {
      this.dialogService.open(EditContentComponent, {
        context: {
          action: ACTIONS.EDIT,
          content: <Content>Content.copy(found)
        }
      });
    } else {
      this.toastrService.show(status, $localize`Content with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public isRealTimeChanged(event) {
    if (event.currentTarget.checked) {
      const found = this.insights.find((element) => element.name === 'empty-insight');
      if (found) {
        this.campaign.trigger_id = found.id;
        this.hideInsightSelect = true;
      } else {
        this.toastrService.show(
          status,
          $localize`Insight "empty-insight" does not exist in this environment, please create one without the query`,
          {
            status: 'danger'
          }
        );
      }
    } else {
      this.hideInsightSelect = false;
    }
    this.campaign.is_real_time = event.currentTarget.checked;
  }

  private openEditInsight(trigger_id) {
    const found = this.insights.find((element) => element.id === trigger_id);

    if (found) {
      this.dialogService.open(EditInsightComponent, {
        context: {
          action: ACTIONS.EDIT,
          insight: <Insight>Insight.copy(found)
        }
      });
    } else {
      this.toastrService.show(
        status,
        $localize`Insight with this ID does not exist, try to refresh the page if the Insight was recently created/activated`,
        {
          status: 'danger'
        }
      );
    }
  }

  private serializeCondition() {
    if (!this.show_condition) {
      this.campaign = { ...this.campaign, condition: null };
      return;
    }

    const condition: any = { AND: [] };

    if (this.show_condition_all && this.condition_all?.length) {
      for (const campaign_id of this.condition_all) {
        condition.AND.push({ campaign_id, time_frame: this.time_frame });
      }
    }

    if (this.show_condition_any && this.condition_any?.length) {
      const or: any[] = [];
      for (const campaign_id of this.condition_any) {
        or.push({ campaign_id, time_frame: this.time_frame });
      }
      if (or.length) condition.AND.push({ OR: or });
    }

    if (this.show_condition_not_all && this.condition_not_all?.length) {
      for (const campaign_id of this.condition_not_all) {
        condition.AND.push({ NOT: { campaign_id, time_frame: this.time_frame } });
      }
    }

    if (this.show_condition_not_any && this.condition_not_any?.length) {
      const or: any[] = [];
      for (const campaign_id of this.condition_not_any) {
        or.push({ NOT: { campaign_id, time_frame: this.time_frame } });
      }
      if (or.length) condition.AND.push({ OR: or });
    }

    this.campaign = { ...this.campaign, condition };
  }

  private deserializeCondition() {
    this.show_condition = this.campaign?.condition;

    if (this.campaign.condition && this.campaign.condition.AND.length > 0) {
      this.campaign.condition.AND.forEach((item) => {
        if (item.campaign_id) {
          this.condition_all.push(item.campaign_id);
          this.time_frame = item.time_frame;
          this.show_condition_all = true;
        } else if (item.NOT) {
          this.condition_not_all.push(item.NOT.campaign_id);
          this.time_frame = item.NOT.time_frame;
          this.show_condition_not_all = true;
        } else if (item.OR) {
          item.OR.forEach((i) => {
            if (i.campaign_id) {
              this.condition_any.push(i.campaign_id);
              this.time_frame = i.time_frame;
              this.show_condition_any = true;
            } else if (i.NOT) {
              this.condition_not_any.push(i.NOT.campaign_id);
              this.time_frame = i.NOT.time_frame;
              this.show_condition_not_any = true;
            }
          });
        }
      });
      this.show_condition = true;
    }
  }

  public editInsight(event) {
    this.store.dispatch(new LoadInsight(event));
    this.action$
      .pipe(ofActionCompleted(LoadInsightSuccess), first(), takeUntil(this.unsubscribe))
      .subscribe((data) => this.openEditInsight(event));
  }
}
